import React from 'react';
import styled from "styled-components";
import colors from "../../styles/colors";
import {BlueButton, DisabledButton} from "../Button";
import {RemoveListIconButton} from "../../pages/new"
import removeList from "../../images/removeList.svg";

const TipsHeading = styled.div`
  width:100%;
  text-align:center;
  font-weight:500;
  font-size:30px
`;
const TipDivision = styled.div`
  width:100%;
  margin-top:20px;

`;
const TipTitleText = styled.div`
  font-weight:500;
  padding:20px
`;
const TipBodyText = styled.div`
  padding:0px 20px 10px 20px;
  margin-top:-10px
  font-size:18px
`;
const InputFields = styled.div`
  padding:15px;
`;
const TipTitleInput = styled.input`
  width:100%;
  height:25px;
  outline: none;
  font-size: 15px;
  color: ${colors.dark};
  &::placeholder {
    color: ${colors.light};
  }
`;
const TipBodyInput = styled.input`
  margin-top:20px;
  width:100%;
  outline: none;
  height:25px;
  font-size: 15px;
  color: ${colors.dark};
  &::placeholder {
    color: ${colors.light};
  }
`;
const ButtonDivision = styled.div`
text-align:center;
margin-top:15px;
margin-bottom:15px
`
const SaveTipsDivision = styled.div`
text-align:center;
margin-top:15px;
`
const RemoveDiv = styled.span`
float:right
`
const Tips = (props) => {
    return (
        <>
            <InputFields>
                <TipTitleInput placeholder={"Tiptitle"} value={props.titleText} onChange={props.onTitleChange}/>
                <TipBodyInput placeholder={"Tiptext"} value={props.bodyText} onChange={props.onBodyChange}/>
            </InputFields>
            <ButtonDivision>
                {props.titleText === '' || props.bodyText === '' ?
                    <DisabledButton>Add new tip</DisabledButton> :
                    <BlueButton onClick={props.onAddTip}>Add new tip</BlueButton>
                }
            </ButtonDivision>
            <TipsHeading>
                Tips för snabba resultat!
            </TipsHeading>
            <TipDivision>
                {props.tips.filter(item => item.userId === props.userId || item.userId === props.masterUserId).map((item, index) => {
                    return (
                        <>
                            <TipTitleText>
                                    {item.tipTitle}
                                    {item.userId === props.userId &&
                                    <RemoveDiv>
                                        <RemoveListIconButton
                                            onClick={() => {
                                                props.onRemoveTips(index)
                                            }}
                                            icon={removeList}/>
                                    </RemoveDiv>
                                    }
                                </TipTitleText>

                                <TipBodyText>
                                    {item.tipDetails}
                                </TipBodyText>

                        </>
                    )
                })}
            </TipDivision>
            <SaveTipsDivision>
                <BlueButton style={{"marginBottom": "20px"}} onClick={props.onSaveTips}>Save</BlueButton>
            </SaveTipsDivision>
        </>
    )

}
export {
    Tips
}



// WEBPACK FOOTER //
// ./src/Components/Tips/index.js